import { render, staticRenderFns } from "./PartnershipInquiryForm.vue?vue&type=template&id=74bfe49c&scoped=true&"
import script from "./PartnershipInquiryForm.vue?vue&type=script&lang=js&"
export * from "./PartnershipInquiryForm.vue?vue&type=script&lang=js&"
import style0 from "./PartnershipInquiryForm.vue?vue&type=style&index=0&id=74bfe49c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bfe49c",
  null
  
)

export default component.exports